/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventdescriptionretranslate2Inputs */

const en_eventdescriptionretranslate2 = /** @type {(inputs: Eventdescriptionretranslate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Translate again`)
};

const de_eventdescriptionretranslate2 = /** @type {(inputs: Eventdescriptionretranslate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übersetzung neu erstellen`)
};

/**
* | output |
* | --- |
* | "Translate again" |
*
* @param {Eventdescriptionretranslate2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventdescriptionretranslate2 = /** @type {((inputs?: Eventdescriptionretranslate2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventdescriptionretranslate2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventdescriptionretranslate2(inputs)
	return de_eventdescriptionretranslate2(inputs)
});
export { eventdescriptionretranslate2 as "eventDescriptionRetranslate" }